import { forwardRef } from "react";
import type { SVGIconProps } from "../types";

export const OsLinuxIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = "currentColor", size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_303"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_303)">
        <path
          d="M9.70103 5.62652C9.42813 5.80852 8.56396 6.30252 8.43401 6.40002C8.18061 6.60152 7.9467 6.58852 7.6933 6.39352C7.56335 6.28952 6.69918 5.79552 6.42628 5.62002C6.1144 5.41852 6.13389 5.16502 6.47826 5.02202C7.54385 4.57352 8.60944 4.60602 9.66854 5.04152C9.98692 5.17802 9.99991 5.43152 9.70103 5.62652ZM14.3922 10.3585C13.788 9.00002 12.9628 7.76502 11.8972 6.67952C11.5675 6.33739 11.3304 5.91681 11.2085 5.45752C11.1435 5.24302 11.098 5.02202 11.0525 4.80102C10.9226 4.22902 10.8641 3.64402 10.5977 3.10452C10.1234 2.07752 9.29818 1.54452 8.10264 1.49902C6.92659 1.53152 6.04942 2.02552 5.53612 3.05902C5.39967 3.33852 5.30221 3.63102 5.23724 3.93002C5.12678 4.42402 5.02932 4.93752 4.91236 5.43802C4.8149 5.86052 4.61997 6.22452 4.2886 6.54952C3.2425 7.57002 2.40432 8.74002 1.76756 10.027C1.6766 10.2155 1.58563 10.404 1.52716 10.599C1.4037 11.028 1.71558 11.327 2.17041 11.223C2.4563 11.1645 2.74219 11.106 3.01509 11.0215C3.28148 10.924 3.38544 10.989 3.45042 11.249C3.87276 12.6465 4.7954 13.628 6.20537 14.174C8.88234 15.188 12.0076 13.745 12.6834 11.197C12.7289 11.0215 12.7938 10.9565 12.9888 11.0215C13.2877 11.1125 13.593 11.1775 13.8984 11.249C14.2168 11.3075 14.4507 11.145 14.4962 10.833C14.5157 10.664 14.4572 10.5145 14.3922 10.3585Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

OsLinuxIcon.displayName = "OsLinuxIcon";
